import { Timezone } from '@uplift/types';
import { restClient } from '../client';
import { State, County } from '../resources';


export const getAllStates = () => restClient.request<{ data: State[] }>('/api/v1/geo/states');
export const getStateById = async (stateId: string) => restClient.request<{ data: State }>(`/api/v1/geo/states/${stateId}`);
export const getCountyByZip = async (zipCode: string) => restClient.request<{ data: County[] }>(`/api/v1/geo/county/${zipCode}`);

export type AllTimezonesResponse = {
  data: Timezone[];
};

export const getAllTimezones = async () => restClient.request<AllTimezonesResponse>('/api/v1/geo/timezones');
